const styles = {
  
    buttonAction: {
        marginLeft: 3,
        marginRight: 3,
    },
    
};
export default styles


// WEBPACK FOOTER //
// ./src/components/ContainerCrud/styles.js